<template>
  <div>

    <v-container
      fluid
      class="content-wrap pb-4"
      :class="$vuetify.breakpoint.smAndDown ? 'pa-0 ma-0' : null"
    >
      <top></top>
      <youtube></youtube>
      <!--
      <timeline v-if="$vuetify.breakpoint.smAndUp"></timeline>
      <countdown></countdown>
      -->
    </v-container>

    <foot></foot>

  </div>
</template>
<style lang="stylus" scoped>

  .content-wrap
    background-color: white !important

</style>
<script>

  import Top from './app/Top'
  import Youtube from './home/Youtube'
  // import Timeline from './home/Timeline'
  // import Countdown from './home/Countdown'
  import Foot from './app/Foot'

  export default {

    components: {
      Top,
      Youtube,
      // Timeline,
      // Countdown,
      Foot,
    }

  }
</script>
